export default __webpack_public_path__ + "static/media/feature-build.a75c878e.svg";